const TOKEN_KEY = 'key'
const USERNAME_KEY = 'username'
const USER_KEY = 'user'
const IS_ADMIN_KEY = 'is_admin'
const EMAIL_KEY = 'email'
const IS_EXTERNAL_KEY = 'is_external'

export const getIsAdmin = () => {
  return JSON.parse(localStorage.getItem(IS_ADMIN_KEY)) || false
}

export const getIsExternal = () => {
  try {
    const value = localStorage.getItem(IS_EXTERNAL_KEY)
    if (value === null || value === undefined || value === 'undefined')
      return false
    return JSON.parse(value)
  } catch (error) {
    console.error('Erreur lors de la récupération de is_external:', error)
    return false
  }
}

// return the user data from the session storage
export const getUser = () => {
  try {
    const firstNameStr = localStorage.getItem('first_name')
    const lastNameStr = localStorage.getItem('last_name')

    if (firstNameStr && lastNameStr) {
      const firstName = JSON.parse(firstNameStr)
      const lastName = JSON.parse(lastNameStr)

      return `${firstName} ${lastName}`
    }
  } catch (error) {
    console.error("Erreur lors de la récupération de l'utilisateur :", error)
  }
  return null
}

// return the token from the session storage
export const getToken = () => {
  console.log('Jessaye de récupérer le toker', localStorage.getItem(TOKEN_KEY))
  return localStorage.getItem(TOKEN_KEY) || null
}

export const getIdUser = () => {
  return JSON.parse(localStorage.getItem('id')) || null
}

export const getUsernameUser = () => {
  return JSON.parse(localStorage.getItem(USERNAME_KEY)) || null
}

export const getEmailUser = () => {
  return JSON.parse(localStorage.getItem(EMAIL_KEY)) || null
}

// remove the token and user from the session storage
export const removeUserSession = () => {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USERNAME_KEY)
  localStorage.removeItem(IS_ADMIN_KEY)
  localStorage.removeItem(EMAIL_KEY)
  localStorage.removeItem(IS_EXTERNAL_KEY)
}

// set the token and user from the session storage
export const setUserSession = (
  token,
  id,
  username,
  first_name,
  last_name,
  is_admin,
  email,
  is_external
) => {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem('id', id)
  localStorage.setItem(USERNAME_KEY, JSON.stringify(username))
  localStorage.setItem('first_name', JSON.stringify(first_name))
  localStorage.setItem('last_name', JSON.stringify(last_name))
  localStorage.setItem(IS_ADMIN_KEY, JSON.stringify(is_admin))
  localStorage.setItem(EMAIL_KEY, JSON.stringify(email))
  localStorage.setItem(IS_EXTERNAL_KEY, JSON.stringify(is_external))
}
